import { createRouter, createWebHashHistory } from "vue-router";
import routes from "./routes.js";
import store from "../store/index.js";

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Global navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.isAuthenticated; // Replace with your authentication logic
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if the route requires authentication
    if (!isAuthenticated) {
      // User is not authenticated, redirect to login or a restricted page
      next("/");
    } else {
      // User is authenticated, proceed to the requested page
      next();
    }
  } else {
    // Route does not require authentication, allow access
    if (!isAuthenticated) {
      next();
    } else {
      next("/dashboard");
    }
  }
});

export default router;
